import * as ko from "knockout";
import { Application } from "../application";
import { PopupType } from "./popupType";

export interface PopupParams {
    visible: KnockoutObservable<boolean>;
    app: Application;
    reject: boolean;
}

export interface PopupParamsWithPlayload<T> extends PopupParams {
    data?: T;
}

export enum PopupMode {
    New,
    NewFromCostRow,
    Edit
}

export class Popup implements PopupParams {

    visible = ko.observable(false);
    reject = false;
    deferred : JQueryDeferred<any> | undefined = undefined;
    
    constructor(public app: Application, public type: PopupType, public component: string) {
        
        this.visible.subscribe((val) => {
            if(val)
                return;

            if(this.deferred) {
                if(this.reject) {
                    this.deferred.reject();
                }
                else {
                    this.deferred.resolve();
                }

                this.deferred = undefined;
            }
        });
    }
}

export class PopupWithPlayload<T> extends Popup implements PopupParamsWithPlayload<T | undefined> {

    data?: T;
    
    constructor(app: Application, type: PopupType, component: string) {
        super(app, type, component);
    }

}


// WEBPACK FOOTER //
// ./ClientApp/services/popups/popup.ts